<template>
  <Header/>
  <SignIn v-if="showLogin"/>
</template>

<script>
import SignIn from "@/views/website/SignIn";
import {onMounted, onUnmounted, provide, ref} from "vue";
import Header from "@/views/HeaderPage";

export default {
  name: 'App',
  components: {
    Header,
    SignIn,
  },

  setup() {
    console.log(process.env.VUE_APP_TITLE);
    const showLogin = ref(true);
    // 判断是否登录
    let authState = localStorage.getItem('authState');
    if (authState) {
      authState = JSON.parse(authState);
      if (authState != null) {
        showLogin.value = !authState.isLoggedIn;
      }
    } else {
      showLogin.value = true;
    }

    const isMobile = ref(false);
    // 检查是否为手机端
    const checkIsMobile = () => {
      isMobile.value = window.innerWidth <= 768; // 假设 768px 是手机端的分界点
    };

    // 监听窗口大小变化
    onMounted(() => {
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile);
    });

    // 移除监听器
    onUnmounted(() => {
      window.removeEventListener('resize', checkIsMobile);
    });

    provide('authState', authState);
    provide('showLogin', showLogin);
    provide('isMobile', isMobile);

    return {
      showLogin,
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.mobile-style {

}

.pc-style {
  padding: 0 50px
}
</style>
